<template>
  <div :class="`quick-access list-process-files col-lg-${options.colSize || 6}`">
    <list-groups :options="options">
      <small slot="action" class="label label-success">
        {{ pagination.total }}
      </small>

      <b-list-group-item
        slot="card"
        v-for="item in items.slice(0, 3)"
        :key="item.id"
        :href="options.link.href + item.process.id || '#!'"
        :target="options.link.target || '_self'"
        class="align-items-start col-lg-6">

        <div class="list-group-item-card">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="col-lg-7 alpha" v-if="item.process.company_name">
              {{ item.process.company_name }}&nbsp;

    <!--           <small>
                <a v-if="get(item, '_links.download', false)"
                  class="mr-1"
                  :href="get(item, '_links.download', '#!')">

                  <i class="fa fa-download"></i> Baixar
                </a>
              </small> -->
            </h5>
            <small class="col-lg-5 omega text-right" v-if="item.created_at">
              <i class="fa fa-clock-o" aria-hidden="true"></i>  Enviado em {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
            </small>
          </div>

          <small v-if="item.attachments.length > 0">
            <fieldset class="attachments">
              <legend align="left">
                Downloads
              </legend>

              <span v-for="(attachment, index) in item.attachments" :key="attachment.id">
                <template v-if="index < 2">

                  <a :href="get(attachment, '_links.download', '#!')">
                    {{ attachment.file.original_name }}
                  </a>

                  <a v-if="index == item.attachments.length - 1 && get(item, '_links', false)"
                    :href="get(item, '_links.download', '#!')" class="item-attachments-btn" v-b-tooltip.hover title="Download">

                    <i class="fa fa-download"></i>
                  </a>

                  <!-- <span v-if="index < item.attachments.length - 1">, </span> -->
                </template>
              </span>

              <!-- <span v-if="item.attachments.length > 2"> + {{ item.attachments.length - 2 }} arquivos</span> -->
            </fieldset>
          </small>

          <ul class="list list-content alpha">
            <li>
              <p class="mb-1">
                <b>Enviado por:</b>&nbsp;

                <span v-if="get(item, 'user.name', false)">
                  {{ get(item, 'user.name', '') }} <small>({{ get(item, 'user.main_role.name', '') }})</small>
                </span>

                <span v-else>
                  Usuário não encontrado
                </span>
              </p>
            </li>
            <li>
              <p class="mb-1">
                <b>Tipo:</b> {{ get(item, 'type.name', 'Sem categoria') }}
              </p>
            </li>
            <li>
              <p class="mb-1" v-if="item.reference_date">
                <b>Referência:</b> {{ item.reference_date | moment('MM/YYYY') }}
              </p>
            </li>
          </ul>
        </div>

      </b-list-group-item>
    </list-groups>
  </div>
</template>

<script>
import { get } from 'lodash'
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-bl-process-files',

  data () {
    return {
      items: [],
      pagination: [],

      options: {
        name: 'Últimos Documentos',
        icon: 'fa fa-files-o',
        colSize: 12,
        entity: {
          url: '/bl/process-submissions',
          params: {
            per_page: 5,
            _order: 'id:desc',
            with: ['type', 'user', 'attachments.file', 'process']
          }
        },
        link: {
          href: '/#/bl-processes/',
          target: '_self'
        }
      }
    }
  },
  methods: {
    get,

    refresh () {
      let self = this

      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },

  created () {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
  fieldset.attachments {
    border: solid 1px #DDD !important;
    padding: 0 10px 10px 10px;
    border-bottom: none;

    legend {
      width: auto !important;
      padding:0 10px; /* To give a bit of padding on the left and right */
      border: none;
      font-size: 14px;
    }
  }

  small {

    font-size: 90%;

  }

  .card-header {
    .card-actions {
      .label {
       padding: 5px 10px;
       border-radius: 2px;
     }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widgets/Bl/ProcessFiles.vue